import type {
  PhotoSearchMatchViewModel,
  PhotoSearchProcessingStep,
} from '../types/photoSearch';

export const LOW_CONFIDENCE_THRESHOLD = 72;

export const getMatchReviewStep = (
  matches: PhotoSearchMatchViewModel[]
): PhotoSearchProcessingStep => {
  const topMatch = matches[0] ?? null;
  const confidencePercent = topMatch?.confidencePercent ?? 0;
  return confidencePercent < LOW_CONFIDENCE_THRESHOLD ? 'low_confidence' : 'idle';
};

export const getInitialPhotoSearchMatchId = (
  matches: PhotoSearchMatchViewModel[]
): string | null => (matches.length === 1 ? matches[0].id : null);

export const getSelectedPhotoSearchMatch = (
  matches: PhotoSearchMatchViewModel[],
  selectedMatchId: string | null
): PhotoSearchMatchViewModel | null =>
  selectedMatchId === null
    ? null
    : matches.find((match) => match.id === selectedMatchId) ?? null;

export const createConfirmedOcrMatch = (
  text: string,
  baseMatch: PhotoSearchMatchViewModel | null
): PhotoSearchMatchViewModel => {
  const normalizedText =
    text.trim() || baseMatch?.normalizedProblem || baseMatch?.ocrText || '手动确认题目';

  return {
    id: baseMatch?.id ? `${baseMatch.id}-confirmed` : 'manual-ocr-confirmed',
    segmentId: baseMatch?.segmentId ?? null,
    title: baseMatch?.title ?? '手动确认题目',
    description: normalizedText,
    ocrText: normalizedText,
    normalizedProblem: normalizedText,
    subject: baseMatch?.subject ?? null,
    grade: baseMatch?.grade ?? null,
    confidencePercent: 100,
    sourceLabel: '手动确认',
    knowledgePoints: baseMatch?.knowledgePoints ?? [],
    needsReview: false,
    cropImageRef: baseMatch?.cropImageRef ?? null,
    bounds: baseMatch?.bounds ?? null,
    detectionOrder: baseMatch?.detectionOrder ?? 1,
    questionNumber: baseMatch?.questionNumber ?? null,
    subquestionLabel: baseMatch?.subquestionLabel ?? null,
  };
};
